import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;


@Component({
  selector: 'app-verifymail',
  templateUrl: './verifymail.component.html',
  styleUrls: ['./verifymail.component.scss']
})
export class VerifymailComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public currentUrl:any ='';
  public token:any='';
  public usertYpes:any=1;

  constructor(public router: Router, private service: GlobalService) {   
  }

  ngOnInit(): void {
    var mm:any =(this.router.url).split('/');  
    this.currentUrl ='/'+ mm[1];
    if(mm.length ==3){
      if( mm[2].includes("?")){
        var ss:any=mm[2].split('?')
        this.token = ss[0];
        var ssd:any= ss[1].split('=');
        this.usertYpes=ssd[1];
      } else {
        this.token = mm[2];
      }
      if(this.currentUrl == '/verify-email'   || this.currentUrl == '/verify-email-mobile' ){
        localStorage.setItem('grw_upload_iamge','1');
        this.OnReset();
      } else{
       if(this.currentUrl == '/success-account-verification'){
        this.callBack('/success-account-verification?stripe_token='+this.token);  
       }  else {
        this.callBack('/failed-account-verification?stripe_token='+this.token);        
      }      
    }
  }
  }

  OnReset(){ 
    this.submitted = true;
    this.loading = true;
    const url = "/verify-email";
    const detail = {
      "verification_token":this.token,
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.submitted = false;
        this.service.successAlert(response.message);
        localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
        this.service.setSubject(response.data);
        localStorage.setItem('grw_token',response.data.token);
        this.loading = false;
        // this.router.navigate(['/signin']);
      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    }), (error) => { this.loading =false; });
  }

  
  callBack(url:any){
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1){
      }
      }))
  }

}
